import { render } from "./ConfigApp.vue?vue&type=template&id=b18b0660&scoped=true"
import script from "./ConfigApp.vue?vue&type=script&lang=js"
export * from "./ConfigApp.vue?vue&type=script&lang=js"

import "./ConfigApp.vue?vue&type=style&index=0&id=b18b0660&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b18b0660"]])

export default __exports__